import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc, collection, query, where, getDocs, setDoc, updateDoc, orderBy, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import "./studentpanel.css";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { motion } from "framer-motion";
import { storage } from "./firebase"; 
import './cpd-panel.css';

const CPDPanel = () => {
  const [selectedOption, setSelectedOption] = useState("home");
  const [studentEmail, setStudentEmail] = useState("");
  const [profileData, setProfileData] = useState(null);
  const [messageType, setMessageType] = useState("inquiry");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [notices, setNotices] = useState([]);
  const [assignmentDeadlines, setAssignmentDeadlines] = useState([]);
  const [googleclassroomLink, setGoogleClassroomLink] = useState("");
  const [materials, setMaterials] = useState([]);
  const [quizLinks, setQuizLinks] = useState([]);
  const [userRegistrationNumber, setUserRegistrationNumber] = useState("");
  const [lectureRecordingLink, setLectureRecordingLink] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); 
  const [moduleFilter, setModuleFilter] = useState(""); 
  const [codeFilter, setCodeFilter] = useState("");
  
  // Add the missing state variables
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isLearningDropdownOpen, setIsLearningDropdownOpen] = useState(false);

  // User Registration ID is fetched properly from profileData
  const userRegistrationId = profileData?.registrationNumber;
  const userBatch = profileData?.batch;

  const auth = getAuth();
  const navigate = useNavigate();

  // Add the missing function
  const toggleLearningDropdown = () => {
    setIsLearningDropdownOpen(!isLearningDropdownOpen);
  };

  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };




  // Handle Send Message with EmailJS
  const handleSend = (e) => {
    e.preventDefault();

    const templateParams = {
      student_email: studentEmail,
      message_type: messageType,
      subject,
      message,
    };

    emailjs
      .send(
        "service_dydfq54",
        "template_4cpxr7d",
        templateParams,
        "VwLqHWZ1TXYthG21f"
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          handleClear();
        },
        (error) => {
          console.error("Failed to send message:", error);
          alert("Failed to send message. Please try again.");
        }
      );
  };




  // Handle Clear Form
  const handleClear = () => {
    setMessageType("inquiry");
    setSubject("");
    setMessage("");
  };







  // Fetch notices
  useEffect(() => {
    const fetchNotices = async () => {
      if (selectedOption === "notice") {
        try {
          const querySnapshot = await getDocs(collection(db, "notices"));
          const noticesData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          
          noticesData.sort((a, b) => {
            const dateA = a.addedDate?.seconds || 0;
            const dateB = b.addedDate?.seconds || 0;
            return dateB - dateA;
          });
          
          setNotices(noticesData);
        } catch (error) {
          console.error("Error fetching notices: ", error);
        }
      }
    };
    fetchNotices();
  }, [selectedOption]);








  // Fetch materials
  useEffect(() => {
    const fetchMaterials = async () => {
      setLoading(true);
      setError("");

      try {
        const materialsRef = collection(db, "materials");
        const querySnapshot = await getDocs(materialsRef);

        const materialsData = querySnapshot.docs.map((doc) => ({
          id: doc.data().id,
          documentId: doc.id,
          moduleName: doc.data().moduleName,
          moduleCode: doc.data().moduleCode,
          fileUrl: doc.data().fileUrl,
        }));

        console.log(materialsData);
        setMaterials(materialsData);
      } catch (err) {
        console.error("Error fetching materials:", err);
        setError("Failed to fetch materials. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, []);








 // Fetch all quiz links
useEffect(() => {
  const fetchUserData = async () => {
    try {
      const userDocRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const registrationNumber = userDoc.data().registrationNumber;
        setUserRegistrationNumber(registrationNumber);

        // Fetch everything from quizMaster (no courseType filter)
        const quizRef = collection(db, "quizMaster");
        const querySnapshot = await getDocs(quizRef);

        const links = [];
        querySnapshot.forEach((doc) => {
          links.push({ id: doc.id, ...doc.data() });
        });

        setQuizLinks(links);
      } else {
        console.log("No such user document!");
      }
    } catch (error) {
      console.error("Error fetching quiz links: ", error);
    }
  };

  fetchUserData();
}, []);








  // Fetch google classroom links
  // Fetch all Google Classroom links
useEffect(() => {
  const fetchUserData = async () => {
    try {
      const userDocRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const registrationNumber = userDoc.data().registrationNumber;
        setUserRegistrationNumber(registrationNumber);

        // Fetch everything from googleclassroom collection (no courseType filter)
        const classroomRef = collection(db, "googleclassroom");
        const querySnapshot = await getDocs(classroomRef);

        const links = [];
        querySnapshot.forEach((doc) => {
          links.push({ id: doc.id, ...doc.data() });
        });

        setGoogleClassroomLink(links);
      } else {
        console.log("No such user document!");
      }
    } catch (error) {
      console.error("Error fetching google classroom links: ", error);
    }
  };

  fetchUserData();
}, []);





  
  // Fetch lecture recordings
useEffect(() => {
  const fetchUserData = async () => {
    try {
      const userDocRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const registrationNumber = userDoc.data().registrationNumber;
        setUserRegistrationNumber(registrationNumber);

        // Fetch all lecture recordings (no CO/DO/HDO filter)
        const recordingsRef = collection(db, "lectureRecordings");
        const querySnapshot = await getDocs(recordingsRef);

        const groupedRecordings = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (!groupedRecordings[data.moduleName]) {
            groupedRecordings[data.moduleName] = [];
          }
          groupedRecordings[data.moduleName].push({
            id: doc.id,
            ...data,
            sessionNumber: parseInt(data.session.replace("Session ", ""))
          });
        });

        // Sort sessions inside each module
        for (const module in groupedRecordings) {
          groupedRecordings[module].sort(
            (a, b) => a.sessionNumber - b.sessionNumber
          );
        }

        // Convert grouped recordings into array
        const sortedRecordings = Object.entries(groupedRecordings).map(
          ([moduleName, sessions]) => ({
            moduleName,
            sessions
          })
        );

        // Sort modules alphabetically
        sortedRecordings.sort((a, b) =>
          a.moduleName.localeCompare(b.moduleName)
        );

        setLectureRecordingLink(sortedRecordings);
      } else {
        console.log("No such user document!");
      }
    } catch (error) {
      console.error("Error fetching recording links: ", error);
    }
  };

  fetchUserData();
}, []);

  



  const filteredRecordings = useMemo(() => {
    if (!Array.isArray(lectureRecordingLink)) {
      return [];
    }

    return lectureRecordingLink.filter(module => {
      if (!module || !module.moduleName || !module.sessions) {
        return false;
      }

      const moduleMatches = !moduleFilter || 
                          module.moduleName.toLowerCase().includes(moduleFilter.toLowerCase());
      
      const searchMatches = !searchTerm ||
                          module.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          module.sessions.some(session => 
                            session && 
                            session.session &&
                            session.lectureRecordingLink &&
                            (
                              session.session.toLowerCase().includes(searchTerm.toLowerCase()) ||
                              session.lectureRecordingLink.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                          );
      
      return moduleMatches && searchMatches;
    });
  }, [lectureRecordingLink, searchTerm, moduleFilter]);






  return (
      <div className="student-dashboard-container">

       <div className="student-sidebar">
         <h2 className="student-sidebar-title">CPD Panel</h2>
         <ul className="student-sidebar-list">
           <li onClick={() => setSelectedOption("home")}>Home</li>

           {/* <li onClick={() => setSelectedOption("module")}>Course Module</li> */}
           <li onClick={() => setSelectedOption("materials")}>Lecture Materials</li>
      
           <li onClick={toggleLearningDropdown} style={{ cursor: "pointer" }}>
           Resources {isLearningDropdownOpen ? "▼" : "▶"}
            </li>
            {isLearningDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
                <li onClick={() => setSelectedOption("learningResources")}>
                Learning Resources
                </li>
                <li onClick={() => setSelectedOption("studyMaterials")}>
                Study Materials
                </li> 
                  </ul>
                )} 

           <li onClick={() => setSelectedOption("guidelines")}>Downloads</li>

           <li onClick={() => setSelectedOption("previousLecVideo")}>Previous Lecture Recordings</li>
           <li onClick={() => setSelectedOption("quizMaster")}>Quiz Master</li>






           <li onClick={() => setSelectedOption("notice")}>Notice Board</li>
           <li onClick={() => setSelectedOption("letter")}>Letter / Inquiry</li>
           <li className="logout-button" onClick={handleLogout}>Logout</li>
         </ul>
       </div>






      {/* Main Panel */}
      <div className="student-panel">
        {selectedOption === "home" && (
          <div className="home-section">
            <div className="home-content">
            <img
              src="/logo.jpg" 
              alt="Eye Care Institute"
              className="home-image"
            />
              <p className="home-description">
             We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
             by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
             and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized by the Ceylon Council of
             Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private institute to be recognized by the 
             Government of Sri Lanka. We are the only Optometry institute affiliated with a university.
              </p>
            </div>

            <div className="vision-mission">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  To be the leader in professional eye care organization by improving the quality
                  and quantity of the service providers in all eye care segments in the region.
                </p>
              </div>

              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                  Improve the quality of life in the region by integrating, sharing, and enhancing
                  experience and innovation with professionals involved in eye care.
                </p>
              </div>
            </div>
          </div>
        )}






{/*************************************************** Study Materials **************************************************************/}


                  {selectedOption === "studyMaterials" && (
                    <div className="quiz-master-container">
                      <h1 className="student-panel-title">Study Materials</h1>
                      <p className="quiz-master-description">
                        Best practices for your academic journey.
                        </p>
                      <div className="quiz-master-link">
                      {googleclassroomLink.length > 0 ? (
                      <table>
                        <thead>
                          <tr>
                            <th>Study Material Link</th>
                          </tr>
                        </thead>
                        <tbody>
                            {googleclassroomLink.map((link) => (
                              <tr key={link.id}>
                                <td>
                                  <a href={link.googleclassroomLink} target="_blank" rel="noopener noreferrer">
                                    Open Study Materials
                                  </a>
                                </td>
                              </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No Study Material Links available at the moment.</p>
                          )}
                      </div>
                    </div>
                  )}


{/*************************************************** Learning Resources **************************************************************/}



                 {selectedOption === "learningResources" && (
                    <div className="quiz-master-container">
                      <h1 className="student-panel-title">Learning Resources</h1>
                      <p className="quiz-master-description">
                        Best practices for your academic journey.
                      </p>
                      <div className="quiz-master-link">
                        
                      <table>
                        <thead>
                          <tr>
                            <th>Learning Resources</th>
                          </tr>
                        </thead>
                        <tbody>
                          
                        <tr>
                            <td>
                              <a
                                href="https://www.aao.org/ophthalmologists"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                 American Academy of Ophthalmology 
                              </a>
                            </td>
                            </tr>

                           <tr>
                            <td>
                              <a
                                href="https://www.reviewofoptometry.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contact Lens Spectrum
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <a
                                href="https://optometry-today.com/contact-lenses/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Optometry Today
                              </a>
                            </td>
                            </tr>



                            <tr>
                            <td>
                              <a
                                href="https://www.healio.com/ophthalmology"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                 Ophthalmic Hyperguide 
                              </a>
                            </td>
                            </tr>

                            <tr>
                            <td>
                              <a
                                href="https://www.reviewofoptometry.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Review of Optometry
                              </a>
                            </td>
                           </tr>

                        </tbody>
                      </table>
                    </div>

                    </div>
                  )}



{/*************************************************** Quiz Master **************************************************************/}



            {selectedOption === "quizMaster" && (
                    <div className="quiz-master-container">
                      <h1 className="student-panel-title">Quiz Master</h1>
                      <p className="quiz-master-description">
                        Best practices for your academic journey.
                      </p>
                      <div className="quiz-master-link">
                      {quizLinks.length > 0 ? (
                      <table>
                        <thead>
                          <tr>
                            <th>Module</th>
                            <th>Test</th>
                            <th>Quiz Link</th>
                          </tr>
                        </thead>
                        <tbody>
                            {quizLinks.map((link) => (
                              <tr key={link.id}>
                                <td>{link.moduleName}</td>
                                <td>{link.Test}</td>
                                <td>
                                  <a href={link.quizLink} target="_blank" rel="noopener noreferrer">
                                    Open Quiz
                                  </a>
                                </td>
                              </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No quizzes available at the moment.</p>
                          )}
                      </div>
                    </div>
              )}






{/*************************************************** Previous Lecture Recordings **************************************************************/}

          {selectedOption === "previousLecVideo" && (
            <div className="previous-lecture-container">
              <h1 className="student-panel-title">Previous Lecture Recordings</h1>
              <p className="previous-lecture--description">
                Best practices for your academic journey.
              </p>
              
              {/* Search and Filter Controls */}
              <div className="lecture-controls">
                <div className="search-filter-container">
                  <input
                    type="text"
                    placeholder="Search recordings..."
                    className="materials-search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  
                  <div className="filter-dropdowns">
                    <select 
                      className="filter-dropdown"
                      value={moduleFilter}
                      onChange={(e) => setModuleFilter(e.target.value)}
                    >
                      <option value="">All Modules</option>
                      {[...new Set(lectureRecordingLink.map(m => m.moduleName))].map(module => (
                        <option key={module} value={module}>{module}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="previous-lecture-link">
                {filteredRecordings.length > 0 ? (
                  filteredRecordings.map((module) => (
                    <div key={module.moduleName} className="module-section">
                      <h3>{module.moduleName}</h3>
                      <table>
                        <thead>
                          <tr>
                            <th>Session No.</th>
                            <th>Lecture Video Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {module.sessions.map((session) => (
                            <tr key={session.id}>
                              <td>{session.session}</td>
                              <td>
                                <a href={session.lectureRecordingLink} target="_blank" rel="noopener noreferrer">
                                  Open Lecture Recording
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))
                ) : (
                  <p>No matching lecture recordings found.</p>
                )}
              </div>
            </div>
          )}












{/******************************************************** materials ********************************************************************/}



          {selectedOption === "materials" && (
            <>
              <h1 className="student-panel-title">Lecture Materials</h1>
              <p className="student-panel-description">
                Access lecture slides, reading materials, and additional resources for your courses.
              </p>

              {/* Search and Filter Controls */}
              <div className="materials-controls">
                <div className="search-filter-container">
                  <input
                    type="text"
                    placeholder="Search materials..."
                    className="materials-search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  
                  <div className="filter-dropdowns">
                    <select 
                      className="filter-dropdown"
                      value={moduleFilter}
                      onChange={(e) => setModuleFilter(e.target.value)}
                    >
                      <option value="">All Modules</option>
                      {[...new Set(materials.map(m => m.moduleName))].map(module => (
                        <option key={module} value={module}>{module}</option>
                      ))}
                    </select>
                    
                    <select 
                      className="filter-dropdown"
                      value={codeFilter}
                      onChange={(e) => setCodeFilter(e.target.value)}
                    >
                      <option value="">All Codes</option>
                      {[...new Set(materials.map(m => m.moduleCode))].map(code => (
                        <option key={code} value={code}>{code}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {loading ? (
                <p className="loading-message">Loading materials...</p>
              ) : error ? (
                <p className="error-message">{error}</p>
              ) : materials.length > 0 ? (
                <div className="materials-table-container">
                  <table className="materials-table">
                    <thead>
                      <tr>
                        <th>Module Name</th>
                        <th>Module Code</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {materials
                        .filter(material => {
                          // Apply search term filter
                          const matchesSearch = 
                            material.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            material.moduleCode.toLowerCase().includes(searchTerm.toLowerCase());
                          
                          // Apply module filter
                          const matchesModule = 
                            !moduleFilter || material.moduleName === moduleFilter;
                          
                          // Apply code filter
                          const matchesCode = 
                            !codeFilter || material.moduleCode === codeFilter;
                          
                          return matchesSearch && matchesModule && matchesCode;
                        })
                        .sort((a, b) => {
                          const moduleCodeComparison = a.moduleCode.localeCompare(b.moduleCode);
                          if (moduleCodeComparison !== 0) return moduleCodeComparison;
                          
                          const sessionA = a.moduleName.match(/\d+/);
                          const sessionB = b.moduleName.match(/\d+/);
                          
                          if (sessionA && sessionB) {
                            return parseInt(sessionA[0], 10) - parseInt(sessionB[0], 10);
                          }
                          return 0;
                        })
                        .map((material) => (
                          <tr key={`${material.id}-${material.documentId}`}>
                            <td>{material.moduleName}</td>
                            <td>{material.moduleCode}</td>
                            <td>
                              <a href={material.fileUrl} target="_blank" rel="noopener noreferrer">
                                Download PDF <span className="download-icon">⬇️</span>
                              </a>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="no-materials-message">
                  No materials available for your batch and program.
                </p>
              )}
            </>
          )}







{/*************************************************** Guidelines **************************************************************/}

        {selectedOption === "guidelines" && (
          <>
            <h1 className="student-panel-title">Course Guidelines</h1>
            <p className="student-guidlines-description">
              Review guidelines, policies, and best practices for your academic journey.
            </p><br />


            <div className="guidelines-downloads">
              <ul>

                <li>
                  <a href="/placementreport.doc" download>
                    Download Student Placement Report
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                
                {/* <li>
                  <a href="/examapplication.pdf" download>
                    Download Exam Application 
                    <span className="download-icon">⬇️</span> 
                  </a>
                </li> */}

                <li>
                  <a href="/Eye Care Institute Course Detail.pdf" download>
                    Download Eye Care Institute Course Details 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                <li>
                  <a href="/Guidelines.pdf" download>
                    Download Course Guidelines 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                <li>
                  <a href="/studentfeedback.pdf" download>
                    Download Lecturer Evaluation 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
              </ul>
            </div>

            <br />
            <p className="student-guidlines-description">Your Lecturer Evaluation Report is available for download. Please review it to provide feedback on your learning experience. Send your evaluation via <b>instituteyecare@gmail.com</b></p>
            <p className="student-guidlines-description">Download the Student Placement Report to view your placement details and opportunities.</p>

          </>
        )}


         





{/************************************ notice board  ******************************************************************/}



            {selectedOption === "notice" && (
              <div>
                <h1 className="student-panel-title">Notice Board</h1>
                <div className="notice-container">
                  {notices.length > 0 ? (
                    notices.map(notice => (
                      <div key={notice.id} className="notice-item">
                        <h3>{notice.subject}</h3>            <h3 className="notice-date">
                          {new Date(notice.addedDate.seconds * 1000).toLocaleString()}
                        </h3>
                        <p className="notice-content">{notice.notice}</p>
                        {notice.hasImage && notice.imageUrl && (
                          <div className="notice-image-container">
                            <img 
                              src={notice.imageUrl} 
                              alt="Notice attachment" 
                              className="notice-image"
                              onClick={() => setSelectedImage(notice.imageUrl)}
                            />
                          </div>
                        )}

                      </div>
                    ))
                  ) : (
                    <p>No notices available.</p>
                  )}
                </div>

                {/* Image modal */}
                {selectedImage && (
                  <div className="image-modal" onClick={() => setSelectedImage(null)}>
                    <div className="image-modal-content">
                      <img src={selectedImage} alt="Full size notice" />
                      <button 
                        className="close-modal"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedImage(null);
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}



{/*************************************************** Inquiry / Feedback **************************************************************/}

              {selectedOption === "letter" && (
                <>
                  <h1 className="student-panel-title">Letter / Inquiry</h1>
                  <form className="contact-form" onSubmit={handleSend}>
                    <label className="form-label">Your Email</label>
                    <input
                      type="email"
                      value={studentEmail}
                      readOnly
                      className="form-input read-only"
                    />

                    <label className="form-label">Message Type</label>
                    <select
                      value={messageType}
                      onChange={(e) => setMessageType(e.target.value)}
                      className="form-input"
                    >
                      <option value="inquiry">Inquiry</option>
                      <option value="request">Request</option>
                      <option value="complaint">Complaint</option>
                      <option value="feedback">Feedback</option>
                    </select>

                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder="Enter subject"
                      className="form-input"
                      required
                    />

                    <label className="form-label">Message</label>
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Write your message here"
                      className="form-textarea"
                      required
                    ></textarea>

                    <div className="form-buttons">
                      <button type="button" className="clear-button" onClick={handleClear}>
                        Clear
                      </button>
                      <button type="submit" className="send-button">
                        Send
                      </button>
                    </div>
                  </form>
                </>
              )}



      </div>
    </div>

  );
};

export default CPDPanel;
